import { useEffect, useState } from "react";
import { Modal, Table, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { general } from "../../../store/action";
import {
  isShowModalDataSelector,
  modalDataSelector,
  modalNameSelector,
} from "../../../store/selector/general";
import Icon from "../general/icon";

type ConsumptionItem = {
  title: string;
  code: string | number;
};

type Props = {
  modalData: any;
  modalName: string;
  isShowModalData: boolean;
  handleHideModal: () => void;
};

const SakhadConsumptionListModal = ({
  modalData,
  modalName,
  isShowModalData,
  handleHideModal,
}: Props) => {
  const [showState, setShowState] = useState(false);
  const [items, setItems] = useState<ConsumptionItem[]>([]);

  useEffect(() => {
    if (isShowModalData && modalName === "sakhadConsumptionListModal") {
      setShowState(true);

      setItems(Array.isArray(modalData) ? modalData : []);
    } else {
      setShowState(false);
    }
  }, [isShowModalData, modalName, modalData]);

  const handleClose = () => {
    setShowState(false);
    handleHideModal();
  };

  return (
    <Modal
      show={showState}
      onHide={handleClose}
      centered
      size="lg"
      contentClassName="rounded-4"
    >
      <Modal.Header closeButton className="border-0 p-4 pb-2">
        <Modal.Title className="font-16 fw-bold text-primary">
          <Icon name="list" /> لیست اطلاعات ساخد
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          <Table hover striped borderless className="m-0">
            <thead
              className="bg-light sticky-top"
              style={{ top: 0, zIndex: 1 }}
            >
              <tr className="border-bottom">
                <th
                  className="text-center py-3 font-12 text-muted"
                  style={{ width: "70px" }}
                >
                  ردیف
                </th>
                <th
                  className="py-3 font-12 text-muted"
                  style={{ width: "120px" }}
                >
                  کد
                </th>
                <th className="py-3 font-12 text-muted">عنوان / شرح</th>
              </tr>
            </thead>
            <tbody>
              {items && items.length > 0 ? (
                items.map((item, index) => (
                  <tr key={index} className="border-bottom">
                    <td className="text-center py-3 text-muted font-13">
                      {index + 1}
                    </td>
                    <td className="py-3 font-13 fw-bold">{item.code}</td>
                    <td className="py-3 font-14">{item.title}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center py-5 text-muted">
                    داده‌ای برای نمایش یافت نشد.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 p-3">
        <Button
          variant="secondary"
          className="rounded-3 px-4"
          onClick={handleClose}
        >
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  modalData: modalDataSelector(state),
  modalName: modalNameSelector(state),
  isShowModalData: isShowModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  handleHideModal: () => dispatch(general.handleHideModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SakhadConsumptionListModal);
